<template>
    <div>
        <button type="button" @click="reboot()" class="btn btn-warning btn-block">REBOOT EM TODOS</button>
    </div>
</template>
<script>
export default {
    data() {
        return {
            user: null
        };
    },
    beforeMount() {
        this.user = this.$store.state.user;
    },
    methods: {
        reboot() {}
    }
};
</script>
